import { FC } from 'react';
import NumberFormat from 'react-number-format';
import { Summary } from '../../../hooks/SubscriptionDetail/useSummary';
import calcPrices from '../../../utils/calcPrices';

import style from './index.module.css';

export const TotalPrice: FC<{
  summary: Summary
}> = ({ summary }) => {

  const { subtotal, deliveryPrice, totalPrice } = calcPrices(summary);

  return (
    <span className={style.price}>
      <i>￥</i>
      <NumberFormat displayType='text' value={totalPrice} thousandSeparator={true}/>
      <small>(税込)</small>
      <small>(送料<DeliveryPrice price={deliveryPrice}/>)</small>
    </span>
  );
}

const DeliveryPrice: FC<{
  price: number
}> = ({ price }) => {

  return price === 0 ? (
    <>無料</>
  ) : (
    <>
      込
    </>
  );
}
